import React from "react";

export default function RoamingHomeBottomBanners() {
    const styles = {
        img:{
            height: '125px'
        }
    }
  return (
    <div className="promo-detail-pg dls-sprint13-comp pse_sm shimmer-effect">
      <h5 className="mt-4 shimmerBG w-30"></h5>
      <div>
        <div className="swiper swiper-wrapper swiper-initialized swiper-horizontal swiper-pointer-events pt-4 swiper-backface-hidden">
          <div
            className="swiper-wrapper"
            style={{transform: "translate3d(0px, 0px, 0px)"}}
          >
           { [1,2].map(item => (<div
              className="swiper-slide"
              style={{width: "218px", marginRight: "12px"}}
            >
              <div
                style={styles.img}
                className="w-100 shimmerBG"
              ></div>
            </div>))}
          </div>
        </div>
      </div>
    </div>
  );
}
